import config from 'lib/config'

/**
 * 2026 rebrand surfaces (portal logo, settings CTA preview).
 * When `REACT_APP_REBRAND_RELEASED` is true, enabled for all users including guests.
 * When false, only clientPids listed in `REACT_APP_REBRAND_TESTERS`.
 * Storefront launcher CTA is CDN-driven (not this gate).
 */
export function canUseRebrand(userId: string | number | undefined | null): boolean {
  if (config.rebrandReleased) return true
  if (userId === undefined || userId === null || userId === '') return false
  const uid = String(userId)
  const allowed = (config.rebrandTesters ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
  return allowed.includes(uid)
}

/** Append ?v=REACT_APP_ASSET_HASH so fixed public paths bust on each Docker image. */
export function withAssetHash(path: string): string {
  const hash = config.assetHash || '0'
  const sep = path.indexOf('?') >= 0 ? '&' : '?'
  return path + sep + 'v=' + encodeURIComponent(hash)
}

/** Portal logo asset paths (under PUBLIC_URL / public/). */
export const SITE_LOGO_LEGACY = withAssetHash('/assets/site-logo.png')
export const SITE_LOGO_REBRAND = withAssetHash('/assets/site-logo-2026.svg')

/** Widget Settings button preview when rebrand is on. */
export const WIDGET_CTA_PREVIEW_REBRAND = withAssetHash(
  '/assets/see-it-in-real-life-button-2026.svg'
)
/** Current production CDN preview (legacy). */
export const WIDGET_CTA_PREVIEW_LEGACY =
  'https://portal.reflektme.app/cdn/widget/img/bgb.svg'
